import { Component } from '@angular/core'

@Component({
  selector: 'change-request-list',
  templateUrl: './change-request-list.component.html',
  styleUrls: ['./change-request-list.component.scss'],
})
export class ChangeRequestListComponent {}
